"use strict";
import axios from "axios";
import store from "../store";

export default class EmailEligibility {
  /**
   * @returns {Promise<boolean>}
   */
  static async checkEligibility() {
    const { data } = await axios.get(
      process.env.NODE_ENV === "development"
        ? `/api/emailEligibility/${store.getters.getMsisdn}`
        : `../${store.getters.getConfig["email_eligibility_url"].replace(
            "{msisdn}",
            store.getters.getMsisdn,
          )}`,
    );

    const targetEligibility = data.eligibilities.find(
      eligibility => eligibility.eventCode === "4",
    );

    return Boolean(targetEligibility?.flag);
  }
}
